"use client";
import { useAuiState } from "@assistant-ui/store";
// TODO should this be renamed to IsRunning?
export const MessagePartPrimitiveInProgress = ({ children }) => {
    const isInProgress = useAuiState(({ part }) => part.status.type === "running");
    return isInProgress ? children : null;
};
MessagePartPrimitiveInProgress.displayName = "MessagePartPrimitive.InProgress";
//# sourceMappingURL=MessagePartInProgress.js.map